import { SaveButton } from 'src/admin/core'
import { useFormikContext } from 'formik'
import { FormEnterprise, useUpsertEnterprise } from '../hooks'
import { Enterprise } from 'src/core/models'
import { useEffect } from 'react'
import { useAppTranslation, useNotification } from 'src/admin/core/hooks'

export const CreateEnterprise: React.FC<{ afterSave?: (promise: Promise<any>, action?: string) => void }> = ({
  afterSave,
}) => {
  const { upsertEnterprise, loading, error } = useUpsertEnterprise()
  const form = useFormikContext()
  const { values, dirty, isValid, setSubmitting } = form
  const { errorNotification } = useNotification()
  const { label } = useAppTranslation()

  useEffect(() => {
    if (error) {
      errorNotification(label(error.message))
    }
  }, [error])

  const handleCreate = () => {
    setSubmitting(true)
    const data = values as FormEnterprise
    const response = upsertEnterprise({
      variables: {
        input: {
          name: data.name,
          domain: data.domain,
          subdomain: data.subdomain,
          active: data.active,
          products: data.products,
          addresses: [
            {
              countryId: data.country?.id,
              cityOrSectorId: data.country?.id,
              address: '',
              stateOrProvinceId: data.country?.id,
              main: true,
              zip: 0,
            },
          ],
        },
      },
    })
    if (afterSave) {
      afterSave(response, 'CREATE')
    }
    setSubmitting(false)
  }

  return <SaveButton onClick={handleCreate} isLoading={loading} disabled={!(dirty && isValid)} />
}
